<template>
  <div id="select-message-template" class="text-center">
    <div>
      <label for="wa-model-message" id="wa-model-message" >
        <strong> {{title}} </strong>
      </label>

      <vs-table
          pagination
          ref="transferTicketTable"
          noDataText="Nenhum template encontrado."
          :data="messageTemplates"
          :max-items="itemsPerPage"
          v-model="selectedTemplateMessage"
          @selected="selectTemplateMessage"
          class="mt-4"
      >
        <template slot="thead">
          <vs-th sort-key="name" v-if="viewCollumns.includes('name')" >Nome</vs-th>
          <vs-th sort-key="status" v-if="viewCollumns.includes('status')">Status</vs-th>
          <vs-th sort-key="category" v-if="viewCollumns.includes('category')">Categoria</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-if="viewCollumns.includes('name')">
              <p class="product-name font-medium">
                {{ tr.name }}
              </p>
            </vs-td>

            <vs-td v-if="viewCollumns.includes('status')">
              <vs-chip :color="parseModelTemplateStatusOrColor(tr.status, true)" class="product-order-status">
                {{ parseModelTemplateStatusOrColor(tr.status, false) }}
              </vs-chip>
            </vs-td>

            <vs-td v-if="viewCollumns.includes('category')">
              <p class="product-name font-medium truncate">
                {{ tr.category }}
              </p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <div v-if="selectedTemplateMessage !== null">
      <div v-if="selectedTemplateMessageHeader !== null">
        <label>
          <strong>Cabeçalho do Template Selecionado</strong>
        </label>

        <textarea
            class="vs-textarea text-area message-text-area"
            v-model="selectedTemplateMessageHeader"
            id="wa-message-template-header"
            style="height: 50px;"
            disabled
        />
      </div>

      <div v-if="formattedBodyMessage !== null" class="mt-5">
        <label>
          <strong>Mensagem do Template Selecionado</strong>
        </label>
        <textarea
            class="vs-textarea text-area message-text-area"
            v-model="formattedBodyMessage"
            id="wa-message-template-body"
            style="height: 100px;"
            disabled
        />
      </div>

      <div v-if="selectedTemplateMessageFooter !== null" class="mt-5">
        <label>
          <strong>Rodapé do Template Selecionado</strong>
        </label>

        <textarea
            v-if="selectedTemplateMessageFooter !== null"
            class="vs-textarea text-area message-text-area"
            v-model="selectedTemplateMessageFooter"
            id="wa-message-template-footer"
            style="height: 50px;"
            disabled
        />
      </div>

      <div v-if="selectedTemplateMessageButtons.length" class="mt-5 d-block">
        <p>
          <strong>Botões do Template Selecionado</strong>
        </p>

        <div class="w-full buttons">
          <div v-for="(item, index) in selectedTemplateMessageButtons" :key="index" >
            <vs-chip>{{ item.text }}</vs-chip>
          </div>
        </div>
      </div>

      <div v-for="(value, index) in templateMessageParametersCountHelper" :key="index" class="mt-5">
        <div v-if="tagList.length">
          <label>
            <strong>Selecione a variável que corresponde ao parâmetro {{ index + 1 }}:</strong>
          </label>

          <div class="params-wrapper mt-5">
            <ul>
              <li v-for="(tag, key) in tagList" :key="`tag-${key}-${index}`">
                <vs-button
                    v-if="templateMessageParameters[index] !== tag"
                    type="flat"
                    color="primary"
                    @click.prevent="insertParamOnRequest(tag, false, index)"
                >
                  {{tag}}
                </vs-button>
                <!--Importante manter aqui como button para não gerar bugs-->
                <button
                    v-else
                    type="button"
                    name="button"
                    class="vs-component vs-button vs-button-primary vs-button-filled isActive"
                    style="background: transparent;"
                >
                  {{tag}}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div v-else >
          <label>
            <strong>Selecione a variável que corresponde ao parâmetro {{ index + 1 }}:</strong>
          </label>
          <div class="params-wrapper mt-5 w-full" style="display: flex; align-items: center;">
              <vs-input
                class="w-full mt-3"
                v-validate="'required'"
                :name="'param-input' + index"
                @focusout.prevent="emitEvent"
                v-model="templateMessageParameters[index]"
                :placeholder="'Insira o conteúdo para ' + (index + 1)"
                style="margin-right: 5px;"
              />
              <vs-button 
                class="mt-3" 
                type="border" 
                :disabled="disabledName(index)" 
                title="Adicionar Nome do Cliente"
                @click="insertName(index)"
                style="align-items: center; display: flex; justify-content: center; padding: 0.7rem 1.5rem;"
              >
                Nome
              </vs-button>

            </div>
            <span class="text-danger text-sm" v-show="errors.has('param-input' + index) && (!templateMessageParameters[index] || templateMessageParameters[index] == '')">
              Preenchimento do campo é obrigatório.
            </span>
        </div>
      </div>
      <div class="text-center items-center" v-if="isIosDevice" style="margin-bottom:8em; margin-top:1.5em;">
        <vs-button
            color="primary"
            type="filled"
            class="align-center"
            :disabled="submitData"
            @click.prevent="$emit('sendMessageTemplate')"
        >
          <span>Enviar Mensagem</span>
        </vs-button>
      </div>
    </div>
    
    <div class="text-center items-center mt-6" v-if="!isIosDevice">
      <vs-button
          color="primary"
          type="filled"
          class="align-center"
          :disabled="submitData"
          @click.prevent="$emit('sendMessageTemplate')"
      >
        <span>Enviar Mensagem</span>
      </vs-button>
    </div>  
  </div>
</template>

<script>

import metaMessageTemplateApi from '@/http/requests/metaMessageTemplate'
import {parseModelTemplateStatusOrColor} from "@/utils";

export default {
  name: "SelectMessageTemplate",
  inject: ['$validator'],
  props: {
    instance: {
      required: false,
      default() {
        return { waba_id: null };
      }
    },
    title: {
      default: 'Selecionar Modelo de Mensagens',
      required: false
    },
    contactName: {
      type: String,
      required: true
    },
    viewCollumns: {
      type: Array,
      required: false,
      default() {
        return ['name', 'status', 'category']
      }
    },
    itemsPerPage: {
      default: 10,
      required: false
    }
  },
  components: {
  },
  data() {
    return {
      tagList: [],
      messageTemplates: [],
      templateMessageParameters: [],
      selectedTemplateMessageButtons: [],
      templateMessageParametersCount: 0,
      formattedBodyMessage: null,
      selectedTemplateMessage: null,
      selectedTemplateMessageBody: null,
      selectedTemplateMessageFooter: null,
      selectedTemplateMessageHeader: null,
    }
  },
  computed:{
    templateMessageParametersCountHelper() {
      if (
          !this.templateMessageParametersCount
      ) { return []; }

      return [...Array(this.templateMessageParametersCount).keys()];
    },
    isIosDevice() {
      const appleDevice = /iPhone|iPad|iPod|Mobile Safari|safari/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent);
      if(appleDevice){
        return true;
      }
      return false;
    }
  },
  watch: {
    'templateMessageParameters': {
      handler: function (val) {
        this.formattedBodyMessage = this.selectedTemplateMessageBody
        val.forEach((example, index) => {
          if (example !== '') {
            this.formattedBodyMessage = this.formattedBodyMessage.replace('{{' + (index + 1) + '}}', example)
          }
        })
      },
      deep: true
    },
    'instance': {
      handler: async function (val) {
        if (val){
          await this.fetchMessageTemplate()
        }
      },
      deep: true
    },
  },
  methods: {
    parseModelTemplateStatusOrColor,
    emitEvent(){
      this.$emit('on-select-template', {
        'selectedTemplate'   : this.selectedTemplateMessage,
        'templateParameters' : this.templateMessageParameters
      });
    },
    insertName(index) {
      this.templateMessageParameters[index] = this.contactName

      this.formattedBodyMessage = this.formattedBodyMessage.replace('{{' + (index + 1) + '}}', this.templateMessageParameters[index])
      this.emitEvent();
    },
    disabledName(index) {
      if (this.templateMessageParameters[index] === undefined) {
        return false;
      }  
      else if(this.templateMessageParameters[index] === '') {
        return false;
      }

      return true;
    },
    selectTemplateMessage(template) {
      this.cleanData()
      this.selectedTemplateMessage = template

      for (const component of template.components) {
        switch (component.type) {
          case 'HEADER':
            this.selectedTemplateMessageHeader = component.text
            break;
          case 'BODY':
            this.selectedTemplateMessageBody = component.text
            this.templateMessageParametersCount = (this.selectedTemplateMessageBody.match(/{{/g) || []).length
            break;
          case 'FOOTER':
            this.selectedTemplateMessageFooter = component.text
            break;
          case 'BUTTONS':
            this.selectedTemplateMessageButtons = component.buttons
            break;
          default:
            break;
        }
      }

      this.emitEvent();
    },
    insertParamOnRequest(param, isFirstMessage, paramNumber) {
      this.templateMessageParameters[paramNumber] = param;
      this.templateMessageParametersCount--;
      this.templateMessageParametersCount++;

      this.emitEvent();
    },
    cleanData(allParams){
      this.templateMessageParameters = [];
      this.selectedTemplateMessageButtons = [];
      this.templateMessageParametersCount = 0;
      this.selectedTemplateMessageBody = null;
      this.selectedTemplateMessageFooter = null;
      this.selectedTemplateMessageHeader = null;

      if ( allParams ){
        this.tagList = [];
        this.selectedTemplateMessage = null;
      }
    },
    async fetchMessageTemplate(){
      this.messageTemplates = (await metaMessageTemplateApi
          .fetch({ waba_id: this.instance.waba_id }))
          .data.data.metaMessageTemplates
    }
  },
  async mounted() {
    await this.fetchMessageTemplate()
  }
}
</script>

<style lang="scss">
#select-message-template{
  .vs-table-text{
    justify-content: center;
  }

  .no-message-alert {
    height: auto !important;
  }

  .buttons {
    padding: 0.5vw;
    margin-top: 1vw;
    border-radius: 1vw;
    display: inline-grid;
    justify-content: center;

    .vs-icon{
      font-size: 0.7rem;
      padding-top: 0.5rem;;
    }

    .con-vs-chip {
      cursor: pointer;
      width: 100% !important;
      &:hover{
        background-color: rgba(var(--vs-primary), 0.2) !important;
      }
    }
  }

}
</style>
